import * as jwtDecode from 'jwt-decode';

import { HttpService } from './http.service';
import StorageService from './storage.service';
import { isDefined, isNull } from '@/common/utils/utils';

const AuthService = {
  USER_API_HOST: process.env.VUE_APP_ADMIN_HOST,

  ROLES: {
    ADMIN: 1,
    SCHOOL: 2,
    STUDENT: 3,
    STUDENT_ONLY: 4
  },

  login(credentials) {
    return HttpService.httpPost(`${this.USER_API_HOST}/api/auth/login`, credentials);
  },

  urlLogin(hash) {
    return HttpService.httpPost(`${this.USER_API_HOST}/api/auth/url-login`, hash);
  },

  loginAsStudent() {
    return HttpService.httpPost(`${this.USER_API_HOST}/api/auth/login/student`);
  },

  logout() {
    StorageService.removeItem(StorageService.KEYS.ACCESS_TOKEN);
  },

  renew() {
    return HttpService.httpPost(`${this.USER_API_HOST}/api/auth/renew`);
  },

  update(updateData) {
    return HttpService.httpPost(`${this.USER_API_HOST}/api/admin/update`, updateData);
  },

  isAuthenticated() {
    try {
      const decodedToken = this.getDecodedToken();

      if (decodedToken && isDefined(decodedToken)) {
        return true;
      }
    } catch (e) {
      return false;
    }
  },

  role() {
    const decodedToken = this.getDecodedToken();
    let userRole = 0;

    if (isDefined(decodedToken)) {

      if (isDefined(decodedToken.role)) {
        for (const role in this.ROLES) {
          if (decodedToken.role === this.ROLES[role]) {
            userRole = this.ROLES[role];
          }
        }
      }
    }

    return userRole;
  },

  getDecodedToken() {
    const token = localStorage.getItem(StorageService.KEYS.ACCESS_TOKEN);

    if (!isNull(token)) {
      return jwtDecode(token);
    }

    return false;
  },

  registerUser(registrationData) {
    return HttpService.httpPost(`${this.USER_API_HOST}/api/register`, registrationData);
  },

  resetPassword(data) {
    return HttpService.httpPost(`${this.USER_API_HOST}/api/reset-password`, data);
  },

  forgotPassword(data) {
    return HttpService.httpPost(`${this.USER_API_HOST}/api/forgot-password`, data);
  },

  updatePassword(data) {
    return HttpService.httpPost( `${this.USER_API_HOST}/api/admin/update-password`, data)
  }
};

export default AuthService;
